module.exports = __webpack_public_path__ + "img/money2.aea3071e.jpg";